import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations-http';
import { IntegrationKinds } from '@recruitee/integrations-types';

@Injectable({ providedIn: 'root' })
export class WerkenInEenHotelApiService extends IntegrationsApiService {
  public context: string = IntegrationKinds.WERKEN_IN_EEN_HOTEL;
}
